module.exports = __webpack_public_path__ + "6cb063521997477d4748adb8b380b0ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/slideshow_09_mobile.jpg
// module id = 660
// module chunks = 0